export default {
  id: '752491586c',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n<div class="page" data-name="bookings">\r\n  <div class="navbar">\r\n    <div class="navbar-bg"></div>\r\n    <div class="navbar-inner sliding">\r\n      <div class="left">\r\n        <a href="#" class="link back">\r\n          <i class="icon icon-back"></i>\r\n          <span class="if-not-md">Back</span>\r\n        </a>\r\n      </div>\r\n      <div class="title">Bookings</div>\r\n    </div>\r\n  </div>\r\n  <div class="page-content">\r\n   <div class="container">\r\n    <div class="popup cancel-booking-popup">\r\n        <div class="block">\r\n          <p><a class="link popup-close" href="#">Close popup</a></p>\r\n          <h4 id="cancelBookingClass">.</h4>\r\n          <h4 id="cancelBookingDay">.</h4>\r\n          <h4 id="cancelBookingTime">.</h4>\r\n          <!-- Close Popup -->\r\n          \r\n          \r\n          <p><a id="cancelBookingButton" class="button popup-close" href="#">Cancel Booking</a></p>\r\n        </div>\r\n    </div>\r\n    \r\n\r\n    <div class="list media-list">\r\n      <ul id="bookingsBigList">\r\n         \r\n      </ul>\r\n    </div>\r\n  </div>\r\n</div>\r\n</div>\r\n';
      return r;
    }(this);
  },

  styleScoped: false
};